import {
  Checkbox,
  createTableColumn,
  Link,
  Tooltip,
  Text,
} from "@fluentui/react-components";
import useWindowSize from "../../helpers/useWindowSize";
import { ILSP3ResponseDto } from "../../Models/ILSP3ResponseDto";
import { useState } from "react";
import i18n from "i18next";

function SelectionServiceColumns() {
  const windowSize = useWindowSize();
  const [clickedArtikel, setClickedArtikel] = useState<
    ILSP3ResponseDto | undefined
  >(undefined);
  const columns = [
    // ------------Artikel------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "artikelId",
      renderHeaderCell: () => {
        return (
          <Tooltip
            content={i18n.t<string>("artikelIdTooltip")}
            relationship="label"
          >
            <Text> {i18n.t<string>("artikelId")}</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        if (windowSize.width > 500) {
          if (item.hasSachwerte) {
            return (
              <Tooltip
                content={i18n.t<string>("displayTechnicalData")}
                relationship="label"
              >
                <Link
                  onClick={(event: any) => {
                    setClickedArtikel(item);
                  }}
                >
                  {" "}
                  {item.artikelId}
                </Link>
              </Tooltip>
            );
          } else {
            return <Text>{item.artikelId}</Text>;
          }
        } else {
          <>
            <Text>{item.artikelId}</Text>
            <Text>
              {item.artikel ? item.artikel.benennungDE : item.benennungDE}
            </Text>
          </>;
        }
      },
    }),
    // ------------ BENNENUNG -------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "benennungM1",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("benennung")}</Text>;
      },
      renderCell: (item) => {
        return (
          <Text>
            {i18n.language.includes("de") ? item.benennungDE : item.benennungEN}
          </Text>
        );
      },
    }),
  ];
  return {
    columns: columns,
    clickedArtikel: clickedArtikel,
  };
}
export default SelectionServiceColumns;
